module.exports = __webpack_public_path__ + "static/media/flag-TR.ca6d1ba7.svg";